module.exports = __webpack_public_path__ + "img/bangkok.cb694d05.png";